module.exports = __webpack_public_path__ + "static/logo512-517cd24f6b6a213486f0c7476ec3e0de.png";